import { cn } from '@crm/ui';
import { TONE_CIRCLE } from './status-tone';

interface StatusHeaderProps {
  icon: React.ReactNode;
  tone?: string;
  title: string;
  detail: string;
  action?: React.ReactNode;
}

export function StatusHeader({ icon, tone = 'info', title, detail, action }: StatusHeaderProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <span
        className={cn(
          'flex h-10 w-10 shrink-0 items-center justify-center rounded-xl',
          TONE_CIRCLE[tone],
        )}
      >
        {icon}
      </span>

      <div className="min-w-0">
        <p className="font-medium">{title}</p>
        <p className="text-sm text-muted-foreground">{detail}</p>
      </div>

      {action ? <div className="ml-auto shrink-0">{action}</div> : null}
    </div>
  );
}
